// JavaScript Document

// Scripts written by Jordan Bearce @ Weblinx, Inc.

import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from "swiper";

const HERO = document.querySelector(".swiper-container--hero");

async function shuffle_slides(singleSwiper) {
    if (singleSwiper.classList.contains("swiper-container--shuffle")) {

        const swiperWrapper = singleSwiper.querySelector(".swiper-wrapper");
        const slides = Array.from(swiperWrapper.querySelectorAll(".swiper-slide"));

        swiperWrapper.querySelectorAll(".swiper-slide").forEach((singleSlide) => {
            swiperWrapper.removeChild(singleSlide);
        });

        // Shuffle the slides array
        for (let i = slides.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [slides[i], slides[j]] = [slides[j], slides[i]];
        }

        // Append the shuffled slides back to the swiper-wrapper
        slides.forEach(slide => swiperWrapper.appendChild(slide));
    }
}

// init swiper
async function init_hero() {
    if (HERO && HERO.querySelectorAll(".swiper-slide").length > 1) {
        await shuffle_slides(HERO);
        const HEROCOUNT = HERO.querySelectorAll(".swiper-slide").length;

        const HEROSWIPER = new Swiper (HERO, {
            modules: [Autoplay, EffectFade, Navigation, Pagination],
            autoplay: {
                delay: 7500,
            },
            effect: "fade",
            loop: true,
            navigation: {
                nextEl: HERO.querySelector(".swiper-button--next"),
                prevEl: HERO.querySelector(".swiper-button--prev"),
            },
            pagination: {
                el: HERO.querySelector(".swiper-pagination"),
                clickable: true,
            },
            speed: 150,
        });

        if (HERO.classList.contains("swiper-container--random-start")) {
            // get a random number between 0 and the number of slides in the slideshow
            const randPos = Math.random();
            const randomIndex = Math.floor(randPos * HEROCOUNT);
            if (randomIndex) {
                HEROSWIPER.slideTo(randomIndex, 0, false);
            }
        }
    }
}

const MULTIVIEW = document.querySelectorAll(".swiper-container--multiview");

// init multiple slides-per-view swipers
async function init_multiviews() {
    if (MULTIVIEW.length > 0) {
        for (const TAB of MULTIVIEW) {

            if (TAB.querySelectorAll(".swiper-slide").length > 1) {
                const TABCOUNT = TAB.querySelectorAll(".swiper-slide").length;

                await shuffle_slides(TAB);

                const view_count = TAB.dataset.slidesperview ? TAB.dataset.slidesperview : 2;
                const view_count_m = TAB.dataset.slidesperviewm ? TAB.dataset.slidesperviewm : 3;
                const view_count_l = TAB.dataset.slidesperviewl ? TAB.dataset.slidesperviewl : 5;
                const swiper = new Swiper (TAB, {
                    modules: [Autoplay, Navigation, Pagination],
                    autoplay: {
                        delay: 7500,
                    },
                    spaceBetween: 20,
                    slidesPerView: 1,
                    loop: true,
                    navigation: {
                        nextEl: TAB.querySelector(".swiper-button--next"),
                        prevEl: TAB.querySelector(".swiper-button--prev"),
                    },
                    pagination: {
                        el: TAB.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                    speed: 150,
                    breakpoints: {
                        300: {
                            slidesPerView: view_count,
                        },
                        500: {
                            slidesPerView: view_count_m,
                            spaceBetween: 30,
                        },
                        991: {
                            slidesPerView: view_count_l,
                        },
                    },
                });

                swiper.on("touchStart", function () {
                    swiper.slides.forEach((slide) => {
                        const link = slide.querySelector(".swiper__link");
                        if (link) {
                            link.style.cursor = "grab";
                        }
                    });
                });

                swiper.on("touchEnd", function () {
                    swiper.slides.forEach((slide) => {
                        const link = slide.querySelector(".swiper__link");
                        if (link) {
                            link.style.cursor = "grab";
                        }
                    });
                });

                if (TAB.classList.contains("swiper-container--random-start")) {
                    // get a random number between 0 and the number of slides in the slideshow
                    const randomIndex = Math.floor(Math.random() * TABCOUNT);
                    if (randomIndex) {
                        swiper.slideTo(randomIndex, 0, false);
                    }
                }
            }
        }

    }
}
document.addEventListener("DOMContentLoaded", init_hero);
document.addEventListener("DOMContentLoaded", init_multiviews);
